import {useState, useEffect, useRef} from 'react'
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column'
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import { Card } from 'primereact/card';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import CurrencyFormat from 'react-currency-format'
import {FilterMatchMode, FilterOperator} from 'primereact/api'
import axios from 'axios'
import {StatementReceipt} from './StatementReceipt'
import {StatementDetail} from './StatementDetail'
import Loader from 'react-js-loader'
import {Link,useLocation} from 'react-router-dom'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}

const StatementList = () => {
  const apiToken = getLocalData().api_token
  const API_URL = process.env.REACT_APP_API_URL
  const GET_STATEMENTS_URL = `${API_URL}/user/Statement`
  const STATEMENT_DETAIL = `${API_URL}/user/Statement/detail`

  const location = useLocation()
  const search_state = location.state

  const [statementData, setStatementData] = useState([])

  const [showStatementDetailModal, setShowStatementDetailModal] = useState(false)
  const [statementItems, setStatementItems] = useState()

  const [showStatementReceiptModal, setShowStatementReceiptModal] = useState(false)
  const [statementId, setStatementId] = useState()
  const [statementUserNo, setStatementUserNo] = useState()
  const [statementCode, setStatementCode] = useState()

  const [loading, setLoading] = useState(false)
  const [loadParams,setLoadParams] = useState({first:0,rows:10})
  const [totalRecords,setTotalRecords] = useState(0)
  const dataFetchCountRef = useRef(0);
  const lastRange = useRef({first:0,rows:10});

  const [globalFilterValue, setGlobalFilterValue] = useState('')
  const [filters, setFilters] = useState({
    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
  })
  const [statusFilter, setStatusFilter] = useState(1)
  const [daysFilter, setDaysFilter] = useState('15')

  const isMobileDevice = MobileUse();
  const data = statementData

  const getStatements = async (statusFilterData, daysFilterData, offsetValue, limitValue,globalFilterValue) => {
    setLoading(true)
    const config = {
      headers: {Authorization: `Bearer ${apiToken}`},
      params: {
          status_filter: statusFilterData,
          days_filter: daysFilterData,
          offset:offsetValue,
          limit:limitValue,
          search:globalFilterValue
        },
    }
    await axios
      .get(GET_STATEMENTS_URL, config)
      .then((response) => {
        setStatementData(prev => [...prev, ...response.data.data])
        setTotalRecords(response.data.total)
        dataFetchCountRef.current += 10
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }
  

  const currentRequest = useRef(false)

  useEffect(() => {
    if(currentRequest.current == false){
      getStatements(statusFilter, daysFilter,loadParams.first,loadParams.rows,globalFilterValue)
      currentRequest.current = true
    }
  }, [loadParams])

  useEffect(() => {
  window.addEventListener("scroll", handleScroll);
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);


const handleScroll = () => {
    const scrollTop = window.scrollY; // current scroll position
    const windowHeight = window.innerHeight; // viewport height
    const fullHeight = document.documentElement.scrollHeight; // total page height

    if (scrollTop + windowHeight >= fullHeight - 5) {
      if(totalRecords == 0 || loadParams.first < totalRecords){
        loadMoreData()
      }
    }
  }

  const loadMoreData = ()=>{ 
    currentRequest.current = false
    const prevFirst = dataFetchCountRef.current;
    const newLoadParams = {first:prevFirst, rows:10};
    
    if(newLoadParams.first > lastRange.current.first){
      setLoadParams(newLoadParams);
      lastRange.current = newLoadParams;
    }
  }

  useEffect(() => {
      if (search_state?.id && search_state?.query) {
        const value = search_state?.query
        setGlobalFilterValue(value)
        setDaysFilter('ALL')
        setStatusFilter('ALL')
        setStatementData([]);
        resetParams()
      }
    }, [search_state])
  

  function checkFileExists(val) {
    // const path = `http://localhost:8000/storage/invoices/statement_invoice_${val.statement_no}.pdf`;
    const path = `https://erp.makemoneyormiles.com/storage/invoices/statement_invoice_${val.statement_no}.pdf`
    if (val.invoice == 1) {
      return (
        <button
          type='button'
          onClick={() => OpenStatementReceiptModal(val.statement_no)}
          class='btn btn-light btn-sm'
        >
          INVOICE
        </button>
      )
    } else {
      if (val.invoice == 2) {
        return <span>----</span>
      } else {
        return <span>PENDING</span>
      }
    }
  }

  const getStatementDetail = async (stmtId) => {
      setLoading(true)
      const config = {
        headers: {Authorization: `Bearer ${apiToken}`},
        params : {
          'statement_id':stmtId
        }
      }
      await axios
        .get(STATEMENT_DETAIL, config)
        .then((response) => {
          setStatementItems(response.data.items)
          // console.log(response.data)
          setLoading(false)
        })
        .catch((error) => {
          console.error(error)
          setLoading(false)
        })
    }

  const getstmtDescription = (val) => {
    let text = ''
    if (val.data_source == 6) {
      let text = 'Opening Balance'
    }
    if (val.data_source == 1) {
      let text = val.name
    }
    return text
  }

  const getstmtCommissionAndTotal = (val) => {
    const totalPrice = val.price * val.qty

    var commission = val.commit_commission
    var totalCommission = commission * val.qty

    const total = totalPrice + totalCommission
    return (
      <>
        <td className='text-danger'>
          <CurrencyFormat
            decimalScale={2}
            value={parseFloat(commission).toFixed(2)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
        </td>
        <td className='text-danger'>
          <CurrencyFormat
            decimalScale={2}
            value={parseFloat(total).toFixed(2)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
        </td>
      </>
    )
  }

  const OpenViewStatementModal = (stmtId) => {
    setStatementId(stmtId)
    getStatementDetail(stmtId)
    setShowStatementDetailModal(true)
  }

  const OpenStatementReceiptModal = (stmtId, stmtcode, userNo) => {
    setStatementId(stmtId)
    setStatementUserNo(userNo)
    setStatementCode(stmtcode)
    setShowStatementReceiptModal(true)
  }

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value
    setStatusFilter(selectedStatus)
    setStatementData([])
    resetParams()
    // getStatements(selectedStatus, daysFilter,0,10)
  }
  const handleDaysChange = (e) => {
    const selectedDays = e.target.value
    setDaysFilter(selectedDays)
    setStatementData([])
    resetParams()
    // getStatements(statusFilter, selectedDays,0,10)
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterValue(value)
    setStatementData([]);
    resetParams()
  }

  const resetParams = ()=>{
    setLoadParams({first:0,rows:10});
    lastRange.current = {first:0,rows:10};
    dataFetchCountRef.current = 0
    currentRequest.current = false
  }

  const renderHeader = () => {
    return (
      <div className='row d-flex justify-content-between align-items-center px-0'>
        <div className='col-lg-6 col-md-12'>
          <input
            value={globalFilterValue}
            className='form-control form-control-sm filter-search-table'
            onChange={onGlobalFilterChange}
            placeholder='Search Tracking/Stmt'
          />
        </div>
        <div className='col-lg-6 col-md-12 d-flex gap-3 align-items-center my-3'>
          <select
            id='statusFilter'
            className='form-select form-select-sm status-filter-select'
            value={statusFilter}
            onChange={handleStatusChange}
          >
            <option value='1'>Active</option>
            <option value='2'>Paid</option>
            <option value='All'>All</option>
          </select>
          <select
            id='daysFilter'
            className='form-select form-select-sm days-filter-select'
            value={daysFilter}
            onChange={handleDaysChange}
          >
            <option value='15'>15 Days</option>
            <option value='30'>30 Days</option>
            <option value='90'>3 Months</option>
            <option value='365'>365 Days</option>
            <option value='All'>All Data</option>
          </select>
        </div>
      </div>
    )
  }

  const ItemsBody = (val) => {
    if (val.source_type == 1) {
      return (
        <button onClick={() => OpenViewStatementModal(val.id)} className='btn btn-sm btn-light'>
          Details
        </button>
      )
    } else {
      ;<span>---</span>
    }
  }
  const AmountBody = (val) => {
    if (val.transaction_type == 'Credit') {
      return (
        <td className='text-success'>
          <CurrencyFormat
            decimalScale={2}
            value={parseFloat(val.total).toFixed(2)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
          {val.payment_status == 1 || val.payment_status == 2 ? (
            <span className='badge badge-primary fs-9'>PAID</span>
          ) : (
            <></>
          )}
        </td>
      )
    } else {
      return (
        <td className='text-danger'>
          <CurrencyFormat
            decimalScale={2}
            value={parseFloat(val.total).toFixed(2)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
        </td>
      )
    }
  }

  const ReceiptBody = (val) => {
    return (
      <button
        type='button'
        onClick={() => OpenStatementReceiptModal(val.statement_no, val.id, val.user_no)}
        class='btn btn-danger btn-sm'
      >
       <i class="bi bi-file-earmark-pdf-fill"></i>&nbsp;&nbsp;INVOICE
      </button>
    )
  }

  const dataViewList = (items)=>{
      return(
        <div className="data-items">
          {
            items.map((item, idx) => (
              <DataViewItem item={item} idx={idx}/>
            ))
          }
        </div>
      )
    }
  
    const DataViewItem = ({item,idx}) =>{
      return(
        <Card key={idx} className="mb-3" style={{borderBottom:'3px solid deepskyblue'}}>
            {/* <div className="p-d-flex p-ai-center mb-2"></div> */}
            <div className="row">
              <div className="col-12">
                <h5 className="">{item.statement_no} ( <span style={{color:'grey'}}>{item.tracking_no}</span> )</h5>
              </div>
              {/* <div className="col-3">
                {ItemsBody(item)}
              </div> */}
              <div className="col-12">
                <span><b>Scanned On : </b>{item.created_at} | <b>Due Date : </b>{item.due_date}</span>
              </div>
              <div className="col-4">
                <h5 className='mt-5'>{AmountBody(item)}</h5>
              </div>
              <div className="col-8 d-flex align-items-center justify-content-center mt-3">
                <div className="me-3">{ItemsBody(item)}</div>
                <div className=''>{ReceiptBody(item)}</div>
              </div>
            </div>
            
            {/* <div className="d-flex align-items-center justify-content-between">
              <div>{statusBody(item)}</div>
              <div className="">{actionBody(item)}</div>
            </div> */}
          </Card>
      )
    }

  const header = renderHeader()

  return (
    <>
      <StatementDetail
        show={showStatementDetailModal}
        handleClose={() => setShowStatementDetailModal(false)}
        items={statementItems}
      />
      <StatementReceipt
        show={showStatementReceiptModal}
        handleClose={() => setShowStatementReceiptModal(false)}
        statementId={statementId}
        userno={statementUserNo}
        statementCode={statementCode}
      />
      <div className='list'>
      {!isMobileDevice ? (
      <div>
        <DataTable
        value={statementData}
        tableStyle={{minWidth: '50rem'}}
        size='large'
        globalFilterFields={['statement_no', 'tracking_no', 'description']}
        dataKey='id'
        filters={filters}
        header={header}
        stripedRows
      >
        <Column field='statement_no' header='Stmt' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column field='tracking_no' header='Tracking' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        {/* <Column field='description' header='Description' style={{width: '25%',paddingTop: 10,paddingBottom: 10}}></Column> */}
        <Column body={ItemsBody} header='Items' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={AmountBody} header='Amount' style={{width: '15%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column field='created_at' header='Scanned On' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column field='due_date' header='DueDate' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={ReceiptBody} header='Receipt' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
      </DataTable>
      </div>
      ) : (
        <div className="card">
          <div className="card-header px-0">{header}</div>
          <div className="card-body px-0 py-1">
            <div className="mobile-card-container">
          {data.length === 0 ? (
            <p className="p-text-center ms-5">You have no statements..</p>
          ) : (
            <DataView 
              value={statementData}
              listTemplate={dataViewList}
            />
          )}
        </div>
          </div>
        </div>
      )}
      <div className="container text-center">
        {loading ? 
          <button type='button' className='btn btn-light w-lg-50 w-100'>Loading...</button>
        :
          <button type='button' className='btn btn-light w-lg-50 w-100' onClick={loadMoreData}>{(loadParams.first <= totalRecords) ? 'Load More' : 'No More Data for this Filter...'}</button>
        }
        
      </div>
      </div>

    </>
  )
}

export default StatementList
